
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { InventoryStockTaking, InventoryStockTakingsUiClient } from '../../../backend/backendapi';
import { handleError, initClient } from '../../../../api';
import InventoryStockTakingStore from '../../../../stores/InventoryStockTakingStore';

@Component({})
export default class StockTakingDeleteModal extends Vue {
  stockTaking: InventoryStockTaking | null = null;
  readonly store = new InventoryStockTakingStore();

  //api
  private readonly service = initClient(InventoryStockTakingsUiClient);

  public open(stockTaking: InventoryStockTaking): void {
    this.stockTaking = stockTaking;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  deleteSelected(): void {
    if (!this.stockTaking) {
      return;
    }
    const toDelete = this.stockTaking;
    this.service.delete(toDelete.id)
        .then(_ => {
          this.$toasted.info(this.$t('txtDeleted').toString());
          this.store.forget(toDelete);
          this.dismiss();
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }
}
